
import {Component, Prop, Vue} from 'vue-property-decorator';
import stores from '@/stores';
import {SweetModal} from 'sweet-modal-vue';
import GlobalFunctions from '@/GlobalFunctions';

@Component({
  components: {
    SweetModal,
  },
})
export default class CreateGuestFlow extends Vue {
  @Prop({default: false})
  emitCreated!: boolean;

  guestFlow: any = {
    name : '',
  };
  firstNameRules = {};
  lastNameRules = {};
  companyRules = {};

  globalFunctions = new GlobalFunctions();
  services: [] = [];
  selectedModule: [] = [];

  mounted() {

    stores.modules.modules()
      .then((response) => {
        this.services = response;
      });
  }

  onSubmit() {
    return stores.GuestFlow.createNewItem(this.guestFlow)
      .then((response) => {
        this.cancel();
        if (this.emitCreated) {
          this.$emit('created', response.data);
          return;
        }
        this.$router.push({name: 'guestflowmodule.show', params: {id: response.data.id}});
      })
      .catch((e) => {
        console.log(e);
      });
  }

  cancel() {
    // @ts-ignore
    this.$children[0].close();
  }
}
